// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YZjmW","selected":"styles_selected__21B-2"};